module.exports = {
  letterSpacing: '',
  colors: {
    text: {
      primary: '#0E1222',
      secondary: '#477C7D',
    },
    bg: {
      primary: '#C9E9EA',
      primaryLight: '#C9E9EA29',
      secondary: '#0E1222',
      tertiary: '#fafafa',
      additional: '#00bcd4',
      colorgrey: 'rgba(250,250,250, 0.08)',
    },
    border: {
      primary: '#C9E9EA',
      secondary: '#000',
      transparent: '#FFFFFF32',
      white: '#fff',
    },
    DatesCore: {
      bg: '#fff',
      text: '#000',
      bgSelected: '#C9E9EA',
      textSelected: '#fff',
    },
    gradient: {
      primary: 'rgba(14, 18, 34, 0.48)',
    },
  },
  fontFamily: {
    primary: ['Clash Display', 'sans-serif'],
    secondary: ['Clash Display', 'sans-serif'],
    indie: ['Clash Display', 'sans-serif'],
  },
}
